"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const routes_json_1 = __importDefault(require("@fos/routes.json"));
const router_1 = require("@jsrouting-bundle/router");
router_1.Routing.setRoutingData(routes_json_1.default);
class SymfonyRouter {
    static getRoute(route, args) {
        return router_1.Routing.generate(route, args, false);
    }
}
exports.default = SymfonyRouter;
